import { COMANDAS } from '../actions/types';

const initialState = {
    listado: [],
    listado_eventos: [],
    detalles: null, 
    ventana_filtros: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case COMANDAS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case COMANDAS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case COMANDAS.EVENTOS:
            return {
                ...state,
                listado_eventos: payload
            };

        case COMANDAS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case COMANDAS.FINALIZAR:
            return {
                ...state,
                listado: state.listado.map(
                    comanda => comanda.id == payload.id ? payload : comanda
                )
            };

        case COMANDAS.REVERTIR:
            return {
                ...state,
                listado: state.listado.map(
                    comanda => comanda.id == payload.id ? payload : comanda
                )
            };

        case COMANDAS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( orden => orden.id !== payload )
            };
        
        default:
            return state;
    }
}